import { createRoot } from 'react-dom/client'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { CssBaseline } from '@mui/material'
import App from '@App'
import { MuiTheme } from '@utils/muiTheme'
import reportWebVitals from '@reportWebVitals'
import './index.css'

function logStartupEnvironment() {
  if (!import.meta.env.DEV) return

  console.groupCollapsed('[startup] import.meta.env snapshot')
  console.table({
    BASE_URL: import.meta.env.BASE_URL,
    MODE: import.meta.env.MODE,
    DEV: import.meta.env.DEV,
    PROD: import.meta.env.PROD,
    VITE_STORYBOOK_IN_APP: import.meta.env.VITE_STORYBOOK_IN_APP,
    VITE_DEV_RAYZE_DONATE_URL: import.meta.env.VITE_DEV_RAYZE_DONATE_URL,
    VITE_DEV_RAYZE_EVENT_URL: import.meta.env.VITE_DEV_RAYZE_EVENT_URL,
    VITE_DEV_RAYZE_ORG_URL: import.meta.env.VITE_DEV_RAYZE_ORG_URL,
    VITE_DEV_RAYZE_INVITE_URL: import.meta.env.VITE_DEV_RAYZE_INVITE_URL,
    VITE_RAYZE_DONATE_URL: import.meta.env.VITE_RAYZE_DONATE_URL,
    VITE_RAYZE_EVENT_URL: import.meta.env.VITE_RAYZE_EVENT_URL,
    VITE_RAYZE_ORG_URL: import.meta.env.VITE_RAYZE_ORG_URL,
    VITE_RAYZE_INVITE_URL: import.meta.env.VITE_RAYZE_INVITE_URL,
  })
  console.groupEnd()
}

// MuiTheme is defined with 'as const' which makes it readonly, but createTheme accepts mutable ThemeOptions
// The type augmentation in global.d.ts ensures compatibility
const theme = createTheme(MuiTheme as Parameters<typeof createTheme>[0])

const container = document.getElementById('rayze')

if (!container) {
  throw new Error('Failed to find the root element')
}

const root = createRoot(container)

// logStartupEnvironment()

root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <App />
  </ThemeProvider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
